<template>
  <!--
          作者：luoyiming
          时间：2019-10-25
          描述：会员-用户列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="关键词">
          <el-input v-model="formInline.nick_name" placeholder="请输入昵称|手机号|ID"></el-input>
        </el-form-item>
        <el-form-item label="推荐人ID">
          <el-input v-model="formInline.referee_id" clearable placeholder="直推列表：该用户ID的下级" style="width: 220px"></el-input>
        </el-form-item>

        <!-- <el-form-item label="会员等级">
          <el-select v-model="formInline.grade_id" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.grade_id">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="实名状态">
          <el-select v-model="formInline.is_realname" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="已实名" :value="1"></el-option>
            <el-option label="未实名" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="注册时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.reg_date" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <!-- 标签筛选暂不展示 -->
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="user_id" label="ID" width="80"></el-table-column>
          <el-table-column prop="nickName" label="昵称"></el-table-column>
          <el-table-column prop="nickName" label="微信头像">
            <template slot-scope="scope">
              <img :src="scope.row.avatarUrl" width="30px" height="30px" />
            </template>
          </el-table-column>
          <!-- 会员等级列改为推荐人 -->
          <el-table-column label="推荐人">
            <template slot-scope="scope">
              <span v-if="scope.row.referee">
                ID：{{ scope.row.referee.user_id }} / {{ scope.row.referee.nickName }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
<!--          <el-table-column label="推荐绑定时间" width="160">-->
<!--            <template slot-scope="scope">-->
<!--              {{ scope.row.referee_bind_time || '-' }}-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column prop="supplier.name" label="绑定商家">
            <template slot-scope="scope">
              <p v-if="scope.row.supplier">{{ scope.row.supplier.name }}</p>
              <p v-else>无</p>
            </template>
          </el-table-column>
          <el-table-column label="商户会员权益" min-width="160">
            <template slot-scope="scope">
              <template v-if="memberBenefitRow(scope.row)">
                <div>
                  <span
                    class="member-benefit-badge"
                    :class="[
                      'member-benefit-lv-' + memberBenefitLevel(scope.row),
                      { 'member-benefit-dimmed': scope.row.supplier.benefit_period_expired }
                    ]"
                  >
                    {{ memberBenefitName(scope.row) }}
                    <em class="member-benefit-id">ID:{{ scope.row.supplier.member_benefit_id }}</em>
                  </span>
                  <el-tag v-if="scope.row.supplier.benefit_period_expired" type="danger" size="mini" style="margin-top:4px;display:block;width:fit-content;">权益已失效</el-tag>
                  <el-tag v-else type="success" size="mini" style="margin-top:4px;display:block;width:fit-content;">权益有效</el-tag>
                </div>
              </template>
              <span v-else class="gray9">-</span>
            </template>
          </el-table-column>
          <!-- 邀请码 -->
          <el-table-column prop="inviter_code" label="邀请码" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.inviter_code || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="is_realname" label="实名状态" width="90">
            <template slot-scope="scope">
              <el-tag size="small" :type="scope.row.is_realname == 1 ? 'success' : 'info'">
                {{ scope.row.is_realname == 1 ? '已实名' : '未实名' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="realname" label="真实姓名" width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.realname || '-' }}</span>
            </template>
          </el-table-column>
          <!-- 余额 -->
          <el-table-column prop="balance" label="余额" width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.balance != null ? scope.row.balance : '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column prop="create_time" label="注册时间" width="140"></el-table-column>
          <el-table-column fixed="right" label="操作" width="170">
            <template slot-scope="scope">
              <!-- <el-button @click="addClick(scope.row)" type="text" size="small" v-auth="'/user/user/recharge'">充值
              </el-button> -->
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/user/user/edit'">编辑
              </el-button>
              <!-- <el-button @click="gradeClick(scope.row)" type="text" size="small" v-auth="'/user/user/grade'">等级</el-button> -->
<!--              <el-button @click="tagClick(scope.row)" type="text" size="small" v-auth="'/user/user/delete'">标签</el-button>-->
              <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/user/user/delete'">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"></el-pagination>
      </div>
    </div>

    <!--会员充值-->
    <Recharge v-if="open_add" :open_add="open_add" :form="userModel" :gradeList="gradeList"
      @closeDialog="closeDialogFunc($event, 'add')"></Recharge>
    <!--会员等级-->
    <Grade v-if="open_edit" :open_edit="open_edit" :form="userModel" :gradeList="gradeList"
      @closeDialog="closeDialogFunc($event, 'edit')"></Grade>
    <!--会员标签-->
    <Tag v-if="open_tag" :open_tag="open_tag" :form="userModel" @closeDialog="closeDialogFunc($event, 'tag')"></Tag>
  </div>
</template>

<script>
  import UserApi from '@/api/user.js';
  import Grade from './dialog/Grade.vue';
  import Recharge from './dialog/Recharge.vue';
  import Tag from './dialog/Tag.vue';
  export default {
    components: {
      /*编辑组件*/
      Grade,
      Recharge,
      Tag
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          nick_name: '',
          referee_id: '',
          grade_id: '',
          reg_date: '',
          tag_id: 0,
          is_realname: ''
        },
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        userModel: {},
        /*等级*/
        gradeList: [],
        open_tag: false,
        /*所有标签*/
        allTag: []
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      /** 是否展示权益（已绑商家且配置了权益） */
      memberBenefitRow(row) {
        const s = row && row.supplier
        return s && Number(s.member_benefit_id) > 0
      },
      memberBenefitLevel(row) {
        const b = row && row.supplier && row.supplier.memberBenefit
        const lv = b && b.level != null ? parseInt(b.level, 10) : 0
        if (lv >= 1 && lv <= 4) return lv
        return 1
      },
      memberBenefitName(row) {
        const b = row && row.supplier && row.supplier.memberBenefit
        return (b && b.name) ? b.name : '权益'
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        UserApi.userlist(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
            self.gradeList = data.data.grade;
            self.allTag = data.data.allTag;
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formInline;
        self.getTableList();
      },

      /*打开添加*/
      addClick(item) {
        this.userModel = item;
        this.open_add = true;
      },
      /*打开编辑*/
      editClick(item) {
        let self = this;
        let params = item.user_id;
        this.$router.push({
          path: '/user/user/edit',
          query: {
            user_id: params
          }
        });
      },
      /*打开编辑*/
      gradeClick(item) {
        this.userModel = item;
        this.open_edit = true;
      },

      tagClick(item) {
        this.userModel = item;
        this.open_tag = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if (f == 'tag') {
          this.open_tag = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },

      /*删除用户*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            self.loading = true;
            UserApi.deleteuser({
                  user_id: row.user_id
                },
                true
              )
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，用户删除成功',
                    type: 'success'
                  });
                  self.getTableList();
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });
          })
          .catch(() => {
            self.loading = false;
          });
      }
    }
  };
</script>
<style lang="scss" scoped>
/* 与后台 4 档权益对应：1白银 2黄金 3钻石 4红金 */
.member-benefit-badge {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.35;
  color: #fff;
  font-weight: 600;
}
.member-benefit-id {
  font-style: normal;
  font-weight: 400;
  opacity: 0.92;
  font-size: 11px;
  margin-top: 2px;
}
.member-benefit-lv-1 {
  background: linear-gradient(135deg, #909399 0%, #b1b6bd 100%);
}
.member-benefit-lv-2 {
  background: linear-gradient(135deg, #e6a23c 0%, #f0c78a 100%);
  color: #5c3d0a;
  .member-benefit-id { color: #5c3d0a; opacity: 0.85; }
}
.member-benefit-lv-3 {
  background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
}
.member-benefit-lv-4 {
  background: linear-gradient(135deg, #f56c6c 0%, #f89898 100%);
}
.member-benefit-dimmed {
  opacity: 0.55;
  filter: grayscale(0.35);
}
.gray9 {
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/views/user/user/index.vue